<template><div/></template>

<script>

import {mapGetters} from 'vuex'

let last = xs => xs[xs.length - 1]

/*
 * @see https://developer.mozilla.org/en-US/docs/Web/API/console
 * We can't cheaply cover every possible case!
 * This is naive check of console message styling.
 */
let isStyledMessage = args =>
  args.length >= 2 &&
  typeof args[0] === 'string' &&
  args[0].indexOf('%c') >= 0

let realize = x =>
  x?.__ob__
    ? {...x}
    : x

let realizeDeeply = x => {
  if (!x) return x /* Exclude null. */
  else

  if (Array.isArray(x)) {
    return x.map(realizeDeeply)
  } else

  if (typeof x === 'object') {
    return Object.fromEntries(
      Object.entries(realize(x))
        .map(([k, v]) => [k, realizeDeeply(v)])
    )
  } else

  if (!x); /* We know, `x` is truish. Then return `x`. */
  else return x
}

let byTimestamp = (a, b) => {
  let [dateA, dateB] = [
    new Date(a.data.timestamp),
    new Date(b.data.timestamp)]

  return dateA === dateB
    ? a._id < b._id ? -1 : 1
    : dateA < dateB ? -1 : 1
}

let emptyState = {
  sessionId: '',
  entries: 0,
  lastId: ''
}

export default {
  name: 'Console',
  props: {
    sessionId: String
  },
  data () {
    return {
      state: emptyState
    }
  },
  computed: {
    ...mapGetters(['sessionConsoleEvents']),
    entries () {
      let x = this
        .sessionConsoleEvents(this.sessionId)
        .sort(byTimestamp)

      return [
        x.map(x => x.data),
        last(x)?._id
      ]
    }
  },
  methods: {
    reset (sessionId) {
      console.clear()
      this.state.sessionId = sessionId
      this.state.entries = 0
      this.state.lastId = ''
    }
  },
  watch: {
    entries ([xs, lastId]) {
      /* We watch it right here, but not in a separate watch,
         because of timings and concurrency. */
      if (this.state.sessionId !== this.sessionId) {
        this.reset(this.sessionId)
      }

      /* Sometimes the last event repeats many times.
         That is why we deduplicate it. */
      if (lastId !== this.state.lastId) {
        /* Slice the news, and render them. */
        xs.slice(this.state.entries)
          .forEach(({timestamp, method, args}) => {
            let realizedArgs = args.map(realizeDeeply)
            let timeStampStr = `[${timestamp}]`

            /* Inject timestamp into first message argument. */
            if (isStyledMessage(args)) realizedArgs[0] = `${timeStampStr} ${realizedArgs[0]}`
            /* Add timestamp inplace as first argument. */
            else realizedArgs.unshift(timeStampStr)

            console[method](...realizedArgs)
          })
      }

      this.state.lastId = lastId
      this.state.entries = xs.length
    }
  }
}
</script>

<style></style>
